<template>
  <v-menu
    offset-y
    :left="true"
    :close-on-content-click="false"
    v-model="isOpenFilterMenu"
  >
    <template v-slot:activator="{ on }">
      <v-btn text color="primary" v-on="on">
        <v-icon small>mdi-filter-outline</v-icon>
        <span class="ml-2">{{ $t("va.datatable.add_filter") }}</span>
      </v-btn>
    </template>
    <v-list class="custom-filter-dropdown">
      <v-tabs
        v-model="tab"
        class="custom-filter-tabs"
        ref="customFilterTabs"
        @hook:mounted="tabsMounted"
      >
        <v-tab v-for="(filter, index) in filtersList" :key="index">
          <span class="letter-spacing-0">{{
            filter.label ? filter.label : filter.source
          }}</span>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="custom-filter-tabs-content">
        <v-tab-item v-for="(filter, index) in filtersList" :key="index">
          <v-card flat>
            <v-card-text
              v-if="
                filter.source === 'domain' || filter.source === 'page.domain'
              "
              class="custom-filter-tabs-content--wrapper"
            >
              <v-text-field
                :placeholder="$t('generic.search_label')"
                clearable
                class="px-4 custom-filter-search"
                v-model="domainSearch"
              ></v-text-field>

              <v-list>
                <v-list-item-group
                  v-model="selectedFilterValues[filter.source]"
                  multiple
                >
                  <v-list-item
                    v-for="(item, index) in getSortedDomainsList"
                    :key="index"
                    :value="item.id"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                          :label="item.text"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text v-if="filter.source === 'type'">
              <v-list>
                <v-list-item-group
                  v-model="selectedFilterValues[filter.source]"
                >
                  <v-list-item
                    v-for="(item, index) in $admin.constants.PAGE_TYPES"
                    :key="index"
                    :value="item.value"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                          :label="item.text"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text
              v-if="
                (filter.source === 'status' ||
                  filter.source === 'page.status') &&
                filter.resource !== 'ab_tests' &&
                filter.resource !== 'phone_numbers'
              "
            >
              <v-list>
                <v-list-item-group
                  v-model="selectedFilterValues[filter.source]"
                  multiple
                >
                  <v-list-item
                    v-for="(item, index) in $admin.constants.PAGE_STATUSES"
                    :key="index"
                    :value="item.value"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                          :label="item.text"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text
              v-if="
                filter.source === 'status' && filter.resource === 'ab_tests'
              "
            >
              <v-list>
                <v-list-item-group
                  v-model="selectedFilterValues[filter.source]"
                  multiple
                >
                  <v-list-item
                    v-for="(item, index) in Object.values(
                      $admin.constants.AB_TEST_STATUSES
                    )"
                    :key="index"
                    :value="item"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          class="capitalize"
                          :input-value="active"
                          color="primary"
                          :label="item"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text
              v-if="
                filter.source === 'status' &&
                filter.resource === 'phone_numbers'
              "
            >
              <v-list>
                <v-list-item-group
                  v-model="selectedFilterValues[filter.source]"
                  multiple
                >
                  <v-list-item
                    v-for="(item, index) in Object.values(
                      $admin.constants.PHONE_NUMBER_STATUSES
                    )"
                    :key="index"
                    :value="item"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          class="capitalize"
                          :input-value="active"
                          color="primary"
                          :label="item"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text v-if="filter.source === 'success'">
              <v-list>
                <v-list-item-group
                  v-model="selectedFilterValues[filter.source]"
                >
                  <v-list-item
                    v-for="(item, index) in $admin.constants.SUCCESS_FILTERS"
                    :key="index"
                    :value="item.value"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                          :label="item.text"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text v-if="filter.source === 'number'">
              <v-list
                v-for="(item, index) in $admin.constants.RINGBA_FILTERS"
                :key="index"
              >
                <div class="custom-filter-tabs-content__label">
                  {{ item.label }}
                </div>
                <v-list-item-group
                  v-model="selectedFilterValues[filter.source]"
                  multiple
                >
                  <v-list-item
                    v-for="(optionItem, index) in item.options"
                    :key="index"
                    :value="optionItem.value"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                          :label="optionItem.text"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text
              v-if="filter.source === 'label' || filter.source === 'page.label'"
              class="custom-filter-tabs-content--wrapper"
            >
              <v-text-field
                :placeholder="$t('generic.search_label')"
                clearable
                class="px-4 custom-filter-search"
                v-model="labelSearch"
              ></v-text-field>
              <v-list>
                <v-list-item-group
                  v-model="noLabelFilter"
                  v-if="searchIncludesNoLabel"
                >
                  <v-list-item @click="handleNoLabel" :value="true">
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                          label="No label"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
                <v-list-item-group
                  v-model="selectedFilterValues[filter.source]"
                  multiple
                >
                  <v-list-item
                    v-for="(item, index) in getSortedLabelsList"
                    :key="index"
                    :value="item.id"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                          :label="item.name"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text
              v-if="filter.source === 'goal'"
              class="custom-filter-tabs-content--wrapper"
            >
              <v-text-field
                :placeholder="$t('generic.search_label')"
                clearable
                class="px-4 custom-filter-search"
                v-model="goalSearch"
              ></v-text-field>
              <v-list>
                <v-list-item-group
                  v-model="selectedFilterValues[filter.source]"
                  multiple
                >
                  <v-list-item
                    v-for="(item, index) in getSortedGoalsList"
                    :key="index"
                    :value="item.id"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                          :label="item.name"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text
              v-if="filter.source === 'owner'"
              class="custom-filter-tabs-content--wrapper"
            >
              <v-text-field
                :placeholder="$t('generic.search_label')"
                clearable
                class="px-4 custom-filter-search"
                v-model="ownerSearch"
              ></v-text-field>
              <v-list>
                <v-list-item-group
                  v-model="selectedFilterValues[filter.source]"
                  multiple
                >
                  <v-list-item
                    v-for="(item, index) in getSortedOwnersList"
                    :key="index"
                    :value="item.id"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                          :label="item.firstName + ' ' + item.lastName"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text v-if="filter.source === 'exists[gtmId]'">
              <v-list>
                <v-list-item-group
                  v-model="selectedFilterValues[filter.source]"
                >
                  <v-list-item
                    v-for="(item, index) in $admin.constants.GTM_FILTERS"
                    :key="index"
                    :value="item.value"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                          :label="item.text"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text v-if="filter.source === 'exists[journayaScript]'">
              <v-list>
                <v-list-item-group
                  v-model="selectedFilterValues[filter.source]"
                >
                  <v-list-item
                    v-for="(item, index) in $admin.constants.JOURNAYA_FILTERS"
                    :key="index"
                    :value="item.value"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                          :label="item.text"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text v-if="filter.source === 'exists[leadspediaId]'">
              <v-list>
                <v-list-item-group
                  v-model="selectedFilterValues[filter.source]"
                >
                  <v-list-item
                    v-for="(item, index) in $admin.constants.LEADSPEDIA_FILTERS"
                    :key="index"
                    :value="item.value"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                          :label="item.text"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text v-if="filter.source === 'formType'">
              <v-list>
                <v-list-item-group
                  v-model="selectedFilterValues['type']"
                  multiple
                >
                  <v-list-item
                    v-for="item in $admin.constants.FORM_TYPE_FILTERS"
                    :key="item.value"
                    :value="item.value"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                          :label="item.text"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>

            <div class="custom-filter-dropdown-buttons">
              <v-btn class="px-8 flex-1" @click="isOpenFilterMenu = false" plain
                >Cancel</v-btn
              >
              <v-btn
                class="px-8 flex-1"
                color="primary"
                @click="updateFiltersValues"
              >
                Apply
                <span v-if="activeFiltersLength"
                  >({{ activeFiltersLength }})</span
                >
              </v-btn>
            </div>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-list>
  </v-menu>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
export default {
  name: "FormFilterList",
  props: {
    filtersList: {
      type: Array,
      default: () => [],
    },
    filterValues: {
      type: Object,
      default: () => {},
    },
    domainsList: {
      type: Array,
      default: () => [],
    },
    labelsList: {
      type: Array,
      default: () => [],
    },
    goalsList: {
      type: Array,
      default: () => [],
    },
    ownersList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tab: 0,
      isOpenFilterMenu: false,
      selectedFilterValues: {},
      domainSearch: "",
      labelSearch: "",
      goalSearch: "",
      ownerSearch: "",
      noLabelFilter: undefined,
      noGoalFilter: undefined,
      noOwnerFilter: undefined,
    };
  },
  computed: {
    getSortedDomainsList() {
      // .sort mutates the original array, that's why we have to create a copy
      // (it's a side effect inside of a computed property if we don't)
      let domainsListDeepCopy = cloneDeep(this.domainsList);

      // Custom simple search query (URL & Name)
      if (this.domainSearch) {
        domainsListDeepCopy = domainsListDeepCopy.filter((domain) =>
          domain?.text.toLowerCase().includes(this.domainSearch.toLowerCase())
        );
      }

      return domainsListDeepCopy.sort((a, b) =>
        a.text !== b.text ? (a.text < b.text ? -1 : 1) : 0
      );
    },
    getSortedLabelsList() {
      let listCopy = cloneDeep(this.labelsList);
      if (this.labelSearch) {
        listCopy = listCopy.filter((label) =>
          label?.name.toLowerCase().includes(this.labelSearch.toLowerCase())
        );
      }

      return listCopy.sort((a, b) =>
        a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0
      );
    },
    getSortedGoalsList() {
      let listCopy = cloneDeep(this.goalsList);

      if (this.goalSearch) {
        listCopy = listCopy.filter((goal) =>
          goal?.name.toLowerCase().includes(this.goalSearch.toLowerCase())
        );
      }

      return listCopy.sort((a, b) =>
        a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0
      );
    },
    getSortedOwnersList() {
      let listCopy = cloneDeep(this.ownersList);

      if (this.ownerSearch) {
        listCopy = listCopy.filter((owner) =>
          (owner?.firstName + " " + owner?.lastName)
            .toLowerCase()
            .includes(this.ownerSearch.toLowerCase())
        );
      }
      return listCopy.sort((a, b) =>
        a.firstName !== b.firstName ? (a.firstName < b.firstName ? -1 : 1) : 0
      );
    },
    searchIncludesNoLabel() {
      if (this.labelSearch) {
        let name = "no label";
        return name.includes(this.labelSearch.toLowerCase());
      } else {
        return true;
      }
    },
    activeFiltersLength() {
      let filtersLength = 0;
      for (const [_key, value] of Object.entries(this.selectedFilterValues)) {
        if (value || typeof value === "boolean") {
          if (typeof value !== "object") {
            filtersLength += 1;
          } else {
            filtersLength += value.length;
          }
        }
      }

      return filtersLength;
    },
  },
  watch: {
    /**
     * Watch for filter values removal / intial set
     */
    filterValues: {
      handler(newVal) {
        if (newVal["exists[label]"] === false) {
          this.noLabelFilter = true;
        } else {
          this.noLabelFilter = false;
        }
        this.selectedFilterValues = { ...newVal };
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /**
     * Fix for the missing 'active' tab underline.
     */
    tabsMounted() {
      setTimeout(() => {
        this.$refs.customFilterTabs && this.$refs.customFilterTabs.onResize();
      }, 0);
    },
    handleNoLabel() {
      if (this.noLabelFilter) {
        this.selectedFilterValues["exists[label]"] = undefined;
      } else {
        this.selectedFilterValues = {
          ...this.selectedFilterValues,
          "exists[label]": !!this.noLabelFilter,
        };
      }
    },
    updateFiltersValues() {
      this.$emit("apply-filters", this.selectedFilterValues);
      this.isOpenFilterMenu = false;
    },
  },
};
</script>
